import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import "styles/master.css";
import React from "react";
import tw from "twin.macro";
import moment from "moment";
import styled from "styled-components";
import {
  getCoreRequests,
  postRequest,
  postCoreRequest,
} from "../helpers/ApiHelper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LoadScript } from "@react-google-maps/api";
import { withRouter } from "react-router-dom";
import Select from "react-select";

const TwoColumn = tw.div`flex flex-col lg:flex-row bg-gray-100`;
const LeftColumn = tw.div`ml-8 mr-8 xl:pl-10 mt-0 pr-8`;
const RightColumn = styled.div`
  ${tw` bg-cover bg-no-repeat  bg-center   h-96 lg:h-auto lg:w-1/2 lg:flex-1`}
`;

const Content = tw.div`mt-24 lg:mt-24 lg:mb-24 flex flex-col sm:items-center lg:items-stretch`;

class QuoteBanner extends React.Component {
  bannerImage = "";
  quoteTitle = "";
  maxPassenger = 11;
  maxLuggage = 20;
  rateData;
  additionalChargeDate;
  fleet_class_types;
  directionsService;
  routeData = {
    distance: {},
    duration: {},
  };
    locationSelect =  {
        start: '',
        end: '',
    };

  constructor(bobe) {
    super(bobe);
    this.state = {
        quoteError: false,
        quoteErrorMessage: "",
        loadingPercent: 0,
        quoteSubmitLoading: false,
        address_types: [],
        startDate: null,
        startTime: null,
        quote: {
            type: "point",
            start: "",
            start_lat: "",
            start_lng: "",
            end: "",
            end_lat: "",
            end_lng: "",
            return_start: "",
            return_start_lat: "",
            return_start_lng: "",
            return_end: "",
            return_end_lat: "",
            return_end_lng: "",
            pickup_date: "",
            pickup_time: "",
            return_pickup_date: "",
            return_pickup_time: "",
            trip_type: "one_way",
            hourly_booked_hours: 4,
            daily_end_date: "",
            daily_booked_days: 1,
            no_of_passengers: 1,
            no_of_luggage: 1,
            vias: [],
            return_vias: [],
        },
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.pickupChange = this.pickupChange.bind(this);
    this.dropChange = this.dropChange.bind(this);
    this.passengerChanged = this.passengerChanged.bind(this);
    this.luggageChanged = this.luggageChanged.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.bannerImage = bobe.fieldData.image;
    this.quoteTitle = bobe.fieldData.title;
    const address_types = bobe.quoteData.address_types;
    this.options = [];
    this.opt = [];
    this.rateData = bobe.quoteData.rateData;
    this.additionalChargeDate = bobe.quoteData.additionalChargeDate;
    this.fleet_class_types = bobe.quoteData.fleet_class_types;
    const locationsArray = address_types.map((a) => a.locations);
    const location_ids = [];
    const locationsList = [];
    locationsArray.forEach((locations, key) => {
      location_ids.push(locations.map((a) => a.location_ref_id));
        locationsList.push(locations);
    });
    const ids = Array.prototype.concat.apply([], location_ids);
    const nLocationsList = Array.prototype.concat.apply([], locationsList);
    getCoreRequests(
      "locations?ids=" + ids.toString() + "&with-coordinates=true"
    ).then((data) => {
      address_types.forEach((location_type) => {
        this.opt= [];
        location_type.locations.forEach((location) => {
          const gLocation = data.find((global_location) => {
            return location.location_ref_id === global_location.id;
          });
          const mLocation = nLocationsList.find((m_location) => {
            return location.location_ref_id === m_location.location_ref_id;
          });
          if (gLocation !== undefined) {
            location.real_name = mLocation && mLocation.name ? mLocation.name : gLocation.name;
            location.lat =
              gLocation.lat_lng !== undefined &&
              gLocation.lat_lng.coordinates !== undefined
                ? gLocation.lat_lng.coordinates[1]
                : undefined;
            location.lng =
              gLocation.lat_lng !== undefined &&
              gLocation.lat_lng.coordinates !== undefined
                ? gLocation.lat_lng.coordinates[0]
                : undefined;
            this.opt.push({ label: location.real_name, value: location.id, lat: location.lat, lng: location.lng, type: gLocation.type});
          }
        });

        this.options.push({ label: location_type.name, options: this.opt.sort( this.compare) });
 
      });

      this.handleChange(address_types);
       
    });
  }
 compare( a, b ) {
    if ( a.label < b.label ){
      return -1;
    }
    if ( a.label > b.label ){
      return 1;
    }
    return 0;
  }

  handleChange(data, type = "address") {
    const state = this.state;
    switch (type) {
      case "address":
        state.address_types = data;
        break;
      case "passenger":
        state.quote.no_of_passengers = data;
        break;
      case "luggage":
        state.quote.no_of_luggage = data;
        break;
      case "time":
        state.startTime = data;
        state.quote.pickup_time = moment(data).format("HH:mm");
        break;
      case "date":
        state.startDate = data;
        state.quote.pickup_date = moment(data).format("YYYY-MM-DD");
        break;
      case "start":
        state.quote.start = data.label;
        this.populateLatLng(state, data, "start");
        this.getGoogleRoute();

        break;
      case "end":
        state.quote.end = data.label;
        this.populateLatLng(state, data, "end");
        this.getGoogleRoute();
        break;
      default:
    }
    state.quoteError = false;
    this.setState(state);
  }

  populateLatLng(state, data, type) {
      this.locationSelect[type] = data.type;
    if (data.value !== null) {
      state.quote[type + "_lat"] = data.lat;
      state.quote[type + "_lng"] = data.lng
    } else {
      state.quote[type + "_lat"] = "";
      state.quote[type + "_lng"] = "";
    }
  }

  getGoogleRoute() {
    const quote = this.state.quote;
    if (
      quote.start_lat !== "" &&
      quote.start_lng !== "" &&
      quote.end_lat !== "" &&
      quote.end_lng !== ""
    ) {
      this.directionsService.route(
        {
          origin: new this.google.maps.LatLng(
            parseFloat(quote.start_lat),
            parseFloat(quote.start_lng)
          ),
          destination: new this.google.maps.LatLng(
            parseFloat(quote.end_lat),
            parseFloat(quote.end_lng)
          ),
          travelMode: this.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === this.google.maps.DirectionsStatus.OK) {
            const routeData = {
              distance: {
                text: "",
                value: 0,
              },
              duration: {
                text: "",
                value: 0,
              },
              route_json: "",
            };
            const legs = result.routes[0].legs;
            let arr = [];
            for (let i = 0; i < legs.length; i++) {
              let steps = legs[i].steps;
              for (let j = 0; j < steps.length; j++) {
                let nextSegment = steps[j].path;
                for (let k = 0; k < nextSegment.length; k++) {
                  arr.push({
                    lat: nextSegment[k].lat(),
                    lng: nextSegment[k].lng(),
                  });
                }
              }
            }
            const resRoute = result.routes[0];

            routeData.distance.value = resRoute.legs[0].distance.value;
            routeData.duration.value = resRoute.legs[0].duration.value;
            routeData.duration.text = resRoute.legs[0].duration.text;
            routeData.distance.text = routeData.distance.value + " meters";
            routeData.route_json = JSON.stringify(resRoute);
            this.routeData = routeData;
          } else {
            this.routeData = {
              distance: {},
              duration: {},
            };
          }
        }
      );
    }
  }
  componentDidMount() {}

  handleDateChange(date) {
    this.handleChange(date, "date");
  }
  handleTimeChange(date) {
    this.handleChange(date, "time");
  }
  pickupChange(date) {
    this.handleChange(date, "start");
  }
  dropChange(date) {
    this.handleChange(date, "end");
  }
  passengerChanged(date) {
    this.handleChange(date.target.value, "passenger");
  }
  luggageChanged(date) {
    this.handleChange(date.target.value, "luggage");
  }

  onFormSubmit(e) {
    e.preventDefault();
    const quote = this.state.quote;
    const state = this.state;
    if (
      quote.start_lat === "" ||
      quote.start_lng === "" ||
      quote.end_lat === "" ||
      quote.end_lng === "" ||
      quote.pickup_date === "" ||
      quote.pickup_time === ""
    ) {
      state.quoteError = true;
      state.quoteErrorMessage = "Please Fill All Required Field.";
      this.setState(state);
      return;
    }
    // if (
    //   (.start === 'airport' && this.locationSelect.end === 'airport' ) || (this.locationSelect.start !== 'airport' && this.locationSelect.end !== 'airport' )
    // ) {
    //   state.quoteError = true;
    //   if(this.locationSelect.start === 'airport' && this.locationSelect.end === 'airport' ){
    //       state.quoteErrorMessage = "Both Addresses Can Not Be  Airport";
    //   }else{
    //       state.quoteErrorMessage = "One Address Must Be Airport";
    //   }
    //
    //   this.setState(state);
    //   return;
    // }

    const data = JSON.parse(JSON.stringify(this.state.quote));
    data.locationData = this.locationSelect;
    postRequest("quote-zone-find", data).then((zoneRes) => {
      if (zoneRes.hasError) {
        state.quoteError = true;
        state.quoteErrorMessage = zoneRes.errorMessage;
        this.setState(state);
      } else {
        localStorage.setItem("airportLocation", this.locationSelect.start);
        state.quoteSubmitLoading = true;
        state.loadingPercent = 25;
        this.setState(state);
        data.rate_data = this.rateData;
        data.additional_charge_data = this.additionalChargeDate;
        data.fleet_type_classes = this.fleet_class_types;
        data.start_zone_id = zoneRes.start_zone_id;
        data.end_zone_id = zoneRes.end_zone_id;
        data.quote_route_id = zoneRes.quote_route_id;
        data.quote_route_type = zoneRes.quote_route_type;
        data.distance = this.routeData.distance;
        data.duration = this.routeData.duration;
        data.timezone = this.timezone;
        postCoreRequest("quote", data).then((res) => {
          if (res.fleets !== undefined) {
            state.loadingPercent = 50;
            this.setState(state);
            res.quote.one_way_route = this.routeData.route_json;
            res.quote.no_of_passengers = data.no_of_passengers;
            res.quote.no_of_luggage = data.no_of_luggage;
            postRequest("quote", res).then((quoteRes) => {
              if (quoteRes.status === "success") {
                state.loadingPercent = 75;
                this.setState(state);
                localStorage.setItem("quoteId", quoteRes.quote_id);
                state.loadingPercent = 100;
                this.setState(state);
                setTimeout(() => {
                  this.props.history.push("/book-fleets");
                }, 500);
              } else {
                state.quoteSubmitLoading = false;
                this.setState(state);
                state.quoteError = true;
                state.quoteErrorMessage = "Error!!!";
              }
            });
          } else {
            state.quoteSubmitLoading = false;
            state.quoteError = true;
            state.quoteErrorMessage = "No Fleet Found";
            this.setState(state);
          }
        });
      }
    });
  }

  onLoad() {
    const google = window.google;
    if (google !== undefined) {
      this.google = google;
      this.directionsService = new google.maps.DirectionsService();
    }
  }

  render() {
    return (
      <TwoColumn>
        <LeftColumn className="hav-quote">
          <Content >
            <div className="hp-quote-wrapper ">
              <h3>{this.quoteTitle}</h3>
              <form onSubmit={this.onFormSubmit}>
                <div className="form-group append-border  ">
                  <div className="input-group select2 mb-2">
                    <Select
                      options={this.options}
                      onChange={this.pickupChange}
                      placeholder="Select Pickup Address"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group select2 mb-2">
                    <Select
                      options={this.options}
                      onChange={this.dropChange}
                      placeholder="Select Drop Off Address"
                    />

                  </div>
                </div>
                <div className="  form-group">
                  <div className="row no-gutter ">
                    <div className="col-md-6">
                      <div className="input-group ">
                        <DatePicker
                            required
                          selected={this.state.startDate}
                          onChange={this.handleDateChange}
                          name="startDate"
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Pickup Date"
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          minDate={new Date()}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-group ">
                        <DatePicker
                          selected={this.state.startTime}
                          onChange={this.handleTimeChange}
                          showTimeSelectOnly
                          showTimeSelect
                          dateFormat="hh:mm aa"
                          timeFormat="hh:mm aa"
                          placeholderText="Pickup Time"
                          timeIntervals={15}
                          type="text"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="  form-group">
                  <div className="row no-gutter  ">
                    <div className="col-md-6">
                      <div className="input-group mb-2">
                        <select className="form-control" onChange={this.passengerChanged}>
                          <option>Passenger Number</option>
                          {[...Array(this.maxPassenger).keys()].map(
                            (number, key) => {
                              return (
                                <option key={key} value={number + 1}>
                                  {number + 1}
                                </option>
                              );
                            }
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-group mb-2">
                        <select className="form-control"  onChange={this.luggageChanged}>
                          <option>Luggage Number</option>
                          {[...Array(this.maxLuggage).keys()].map(
                            (number, key) => {
                              return (
                                <option key={key} value={number + 1}>
                                  {number + 1}
                                </option>
                              );
                            }
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.quoteError && (
                  <div className="form-group mt-3">
                    <p className="text-danger">
                      {this.state.quoteErrorMessage}
                    </p>
                  </div>
                )}

                <div className="form-group mt-3">
                  <button className="btn btn-yellow btn-block pt-3 pb-3">
                    Proceed
                  </button>
                  {this.state.quoteSubmitLoading && (
                    <div className="progress">
                      <div
                        className="progress-bar bg-warning"
                        role="progressbar"
                        style={{ width: this.state.loadingPercent + "%" }}
                        aria-valuenow={this.state.loadingPercent}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </Content>
        </LeftColumn>
        <RightColumn
          style={{ backgroundImage: `url(${this.bannerImage})` }}
        ></RightColumn>
        <LoadScript
          googleMapsApiKey={"AIzaSyDyTJUE1-ZOt3WmqonHbK1U9vFGpablM88"}
          loadingElement={<div />}
          containerElement={<div />}
          mapElement={<div />}
          onLoad={this.onLoad()}
        ></LoadScript>
      </TwoColumn>
    );
  }
}
export default withRouter(QuoteBanner);
